import React, { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DynamicHelmet from "./components/DynamicHelmet/DynamicHelmet";
import { useAuth } from "./context/AuthContext";
import { useAvailableModulesContext } from "./context/AvailableModulesContext";
import RoutesObject from "./helpers/Routes";
import { AuditLogDetails } from "./pages/auditLog/AuditLogDetails";
import AuditLogIndex from "./pages/auditLog/AuditLogIndex";
import ForgotPassword from "./pages/auth/ForgotPassword";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import ResetPassword from "./pages/auth/ResetPassword";
import AuxiliaryEquipmentCreate from "./pages/auxiliaryEquipments/AuxiliaryEquipmentCreate";
import AuxiliaryEquipmentEdit from "./pages/auxiliaryEquipments/AuxiliaryEquipmentEdit";
import AuxiliaryEquipmentIndex from "./pages/auxiliaryEquipments/AuxiliaryEquipmentIndex";
import AssistanceEdit from "./pages/backoffice/AssistanceEdit";
import Backoffice from "./pages/backoffice/Backoffice";
import CriarAssistencia from "./pages/backoffice/CriarAssistencia";
import CheckListModelCreate from "./pages/checkListModel/CheckListModelCreate";
import CheckListModelEdit from "./pages/checkListModel/CheckListModelEdit";
import CheckListModelIndex from "./pages/checkListModel/CheckListModelIndex";
import CheckListModelTaskDetails from "./pages/checkListModelTask/checkListModelTaskDetails";
import ClientCreate from "./pages/client/ClientCreate";
import ClientEdit from "./pages/client/ClientEdit";
import ClientIndex from "./pages/client/ClientIndex";
import ClientQuotationIndex from "./pages/clientQuotation/ClientQuotationIndex";
import CreateClientQuotation from "./pages/clientQuotation/CreateClientQuotation";
import DetailsClientQuotation from "./pages/clientQuotation/DetailsClientQuotation";
import InvalidToken from "./pages/clientQuotation/InvalidToken";
import ReviewClientQuotation from "./pages/clientQuotation/ReviewClientQuotation";
import CountryCreate from "./pages/countries/CountryCreate";
import CountryEdit from "./pages/countries/CountryEdit";
import CountryIndex from "./pages/countries/CountryIndex";
import DeliveryNoteEdit from "./pages/deliveryNotes/DeliveryNoteEdit";
import DeliveryNoteIndex from "./pages/deliveryNotes/DeliveryNoteIndex";
import DeliveryNoteUnsubmittedIndex from "./pages/deliveryNotes/DeliveryNoteUnsubmittedIndex";
import EquipmentCreate from "./pages/equipments/EquipmentCreate";
import EquipmentEdit from "./pages/equipments/EquipmentEdit";
import EquipmentIndex from "./pages/equipments/EquipmentIndex";
import FileTypeEdit from "./pages/fileTypes/FileTypeEdit";
import FileTypesIndex from "./pages/fileTypes/FileTypesIndex";
import HolidayCreate from "./pages/Holidays/HolidayCreate";
import HolidayEdit from "./pages/Holidays/HolidayEdit";
import HolidayIndex from "./pages/Holidays/HolidayIndex";
import ImportIndex from "./pages/import/ImportIndex";
import KpiAssistancesDifferentStartEndDate from "./pages/kpi/KpiAssistancesDifferentStartEndDate";
import KpiAssistances from "./pages/kpi/KpiAssistancesExecutionNotFinished";
import KpiBrandModel from "./pages/kpi/KpiBrandModel";
import KpiClientAssistancesHistoryContainer from "./pages/kpi/KpiClientAssistancesHistoryContainer";
import KpiClientDashboard from "./pages/kpi/KpiClientDashboard";
import KpiIndex from "./pages/kpi/KpiIndex";
import KpiTotalTimeOver7Hours from "./pages/kpi/KpiITotalTimeOver7Hours";
import KpiOpenAssistancesMoreThan10Days from "./pages/kpi/KpiOpenAssistancesMoreThan10Days";
import KpiTechnicianDashboard from "./pages/kpi/KpiTechnicianDashboard";
import MaintenancePlanCreate from "./pages/maintenancePlan/MaintenancePlanCreate";
import MaintenancePlanEdit from "./pages/maintenancePlan/MaintenancePlanEdit";
import MaintenancePlanIndex from "./pages/maintenancePlan/MaintenancePlanIndex";
import NoAuthorization from "./pages/NoAuthorization";
import CounterTypeCreate from "./pages/counters/CounterTypeCreate";
import CounterTypeIndex from "./pages/counters/CounterTypeIndex";
import PartCreate from "./pages/parts/PartCreate";
import PartEdit from "./pages/parts/PartEdit";
import PartList from "./pages/parts/PartList";
import ProjectCreate from "./pages/projects/ProjectCreate";
import ProjectEdit from "./pages/projects/ProjectEdit";
import ProjectIndex from "./pages/projects/ProjectIndex";
import ReminderDetails from "./pages/reminder/ReminderDetails";
import ReminderIndex from "./pages/reminder/ReminderIndex";
import SchedulerIndex from "./pages/scheduler/SchedulerIndex";
import { SettingsEdit } from "./pages/settings/SettingsEdit";
import SettingsIndex from "./pages/settings/SettingsIndex";
import SettingsIndexV2 from "./pages/settings/SettingsIndexV2";
import StatusCreate from "./pages/status/StatusCreate";
import StatusEdit from "./pages/status/StatusEdit";
import StatusIndex from "./pages/status/StatusIndex";
import SubcontractorCreate from "./pages/subcontrator/SubcontractorCreate";
import SubcontractorEdit from "./pages/subcontrator/SubcontractorEdit";
import SubcontractorIndex from "./pages/subcontrator/SubcontractorIndex";
import CreateSupplierQuotation from "./pages/supplierQuotation/CreateSupplierQuotation";
import DetailsSupplierQuotation from "./pages/supplierQuotation/DetailsSupplierQuotation";
import SupplierQuotationIndex from "./pages/supplierQuotation/SupplierQuotationIndex";
import SupplierCreate from "./pages/suppliers/SupplierCreate";
import SupplierEdit from "./pages/suppliers/SupplierEdit";
import SupplierIndex from "./pages/suppliers/SupplierIndex";
import UserCreate from "./pages/users/UserCreate";
import UserEdit from "./pages/users/UserEdit";
import UserIndex from "./pages/users/UserIndex";
import Version from "./pages/version/Version";
import { AssistanceCreate } from "./pages/workshop/AssistanceCreate";
import { AssistanceDetails } from "./pages/workshop/AssistanceDetails";
import AssistanceList from "./pages/workshop/AssistanceList";
import { AssistanceSearchCreate } from "./pages/workshop/AssistanceSearchCreate";
import Workshop from "./pages/workshop/Workshop";
import "./styles/App.css";

interface PrivateRouteProps {
	component: React.FunctionComponent;
	loggedIn: boolean;
	userRoles?: string[];
	requiredRoles?: string[];
}

const PrivateRoute = (props: PrivateRouteProps) => {
	if (props.loggedIn === false) {
		return <Navigate to="/login" replace />;
	}

	//Se não foi especificado roles para a route
	if (
		typeof props.requiredRoles === "undefined" ||
		props.requiredRoles == null ||
		props.requiredRoles.length <= 0
	) {
		return <props.component />;
	}

	//Foram especificados roles para a route, mas o user não tem roles
	if (
		typeof props.userRoles === "undefined" ||
		props.userRoles === null ||
		props.userRoles.length <= 0
	) {
		return <Navigate to="/NoAuthorization" replace />;
	}

	var userHasSomeRole: boolean = props.requiredRoles.some((r) =>
		props.userRoles!.includes(r)
	);

	return userHasSomeRole ? (
		<props.component />
	) : (
		<Navigate to="/NoAuthorization" replace />
	);
};


const PublicRoute = (props: { component: React.FunctionComponent }) => {
	return <props.component />;
}

function App() {
	const { isUserLoggedIn, userRoles, preferedView, isTechnician } = useAuth();
	const { availableModules, canTechnicianCreateAssistances } = useAvailableModulesContext();
	const [technicianHasPermission, setTechnicianHasPermission] = useState<boolean>(false);

	//modulos ativos
	useEffect(() => {
		if (availableModules.includes("TechnicianHasPermission")) {
			setTechnicianHasPermission(true);
		}
	}, [availableModules]);

	return (
		<div className="App">
			<DynamicHelmet />
			<ToastContainer
				bodyClassName="myToast"
				position="bottom-right"
				autoClose={5000}
				pauseOnFocusLoss={false}
				pauseOnHover={true}
				hideProgressBar={true}
			/>

			<BrowserRouter>
				<Routes>
					{/* Rotas Basicas */}
					<Route
						path="/"
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								component={
									preferedView?.toUpperCase() === "OFICINA"
										? (isTechnician() && !canTechnicianCreateAssistances
											? AssistanceList
											: Workshop)
										: Backoffice
								}
							/>
						}
					/>

					<Route
						path="/NoAuthorization"
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								component={NoAuthorization}
							/>
						}
					/>

					{/* Rotas de Autenticação */}
					<Route path="/login" element={<Login />} />
					<Route path="/ForgotPassword" element={<ForgotPassword />} />
					<Route path="/ResetPassword" element={<ResetPassword />} />
					<Route path="/Register" element={<Register />} />

					{/* Rotas Gestão de Utilizadores */}
					<Route
						path={RoutesObject.users.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
								component={UserIndex}
							/>
						}
					/>

					<Route
						path={RoutesObject.users.create}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
								component={UserCreate}
							/>
						}
					/>

					<Route
						path={`${RoutesObject.users.details}/:id`}
						element={
							<PrivateRoute loggedIn={isUserLoggedIn} component={UserEdit} />
						}
					/>

					{/* Rotas Gestão Clientes */}
					<Route
						path={RoutesObject.clients.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
								component={ClientIndex}
							/>
						}
					/>

					<Route
						path={RoutesObject.clients.create}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
								component={ClientCreate}
							/>
						}
					/>

					<Route
						path={`${RoutesObject.clients.details}/:id`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
								component={ClientEdit}
							/>
						}
					/>

					{/* Rotas Gestão Peças */}
					<Route
						path={RoutesObject.parts.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
								component={PartList}
							/>
						}
					/>

					<Route
						path={RoutesObject.parts.create}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
								component={PartCreate}
							/>
						}
					/>

					<Route
						path={`${RoutesObject.parts.details}/:id`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
								component={PartEdit}
							/>
						}
					/>

					{/* Rotas Gestão Obras */}
					<Route
						path={RoutesObject.projects.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
								component={ProjectIndex}
							/>
						}
					/>

					<Route
						path={RoutesObject.projects.create}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
								component={ProjectCreate}
							/>
						}
					/>

					<Route
						path={`${RoutesObject.projects.details}/:id`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
								component={ProjectEdit}
							/>
						}
					/>

					{/* Rotas Gestão Equipamentos */}
					<Route
						path={RoutesObject.equipments.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Admin"]}
								component={EquipmentIndex}
							/>
						}
					/>

					<Route
						path={RoutesObject.equipments.create}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Admin"]}
								component={EquipmentCreate}
							/>
						}
					/>

					<Route
						path={`${RoutesObject.equipments.details}/:id`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Admin"]}
								component={EquipmentEdit}
							/>
						}
					/>

					{/* Rotas Gestão Equipamentos Auxiliares*/}
					<Route
						path={RoutesObject.auxiliaryEquipments.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Admin"]}
								component={AuxiliaryEquipmentIndex}
							/>
						}
					/>

					<Route
						path={`${RoutesObject.auxiliaryEquipments.details}/:erpId`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Admin"]}
								component={AuxiliaryEquipmentEdit}
							/>
						}
					/>

					<Route
						path={RoutesObject.auxiliaryEquipments.create}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Admin"]}
								component={AuxiliaryEquipmentCreate}
							/>
						}
					/>

					{/* Rotas Gestão FileTypes */}
					<Route
						path={RoutesObject.fileTypes.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
								component={FileTypesIndex}
							/>
						}
					/>

					<Route
						path={RoutesObject.auditLogs.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Admin"]}
								component={AuditLogIndex}
							/>
						}
					/>
					<Route
						path={`${RoutesObject.auditLogs.details}/:id`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Admin"]}
								component={AuditLogDetails}
							/>
						}
					/>

					<Route
						path={`${RoutesObject.fileTypes.details}/:id`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
								component={FileTypeEdit}
							/>
						}
					/>

					{/* Rotas Gestão Settings */}
					<Route
						path={RoutesObject.settings.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Admin"]}
								component={SettingsIndex}
							/>
						}
					/>

					<Route
						path={`${RoutesObject.settings.details}/:id`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Admin"]}
								component={SettingsEdit}
							/>
						}
					/>

					{/* Rotas Gestão Settings v2 */}
					<Route
						path={RoutesObject.settingsv2.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Admin"]}
								component={SettingsIndexV2}
							/>
						}
					/>

					{/* Rotas Vista de Oficina */}
					<Route
						path={RoutesObject.oficina.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								component={Workshop}
								userRoles={userRoles}
								requiredRoles={["Técnico Oficina", "Admin"]}
							/>
						}
					/>

					<Route
						path={RoutesObject.oficina.details}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								component={Workshop}
								userRoles={userRoles}
								requiredRoles={["Técnico Oficina", "Admin"]}
							/>
						}
					/>

					<Route
						path={RoutesObject.oficina.create}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								component={AssistanceSearchCreate}
								userRoles={userRoles}
								requiredRoles={["Técnico Oficina", "Admin"]}
							/>
						}
					/>

					<Route
						path={`${RoutesObject.oficina.create}/:equipmentErpId`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								component={AssistanceCreate}
								userRoles={userRoles}
								requiredRoles={["Técnico Oficina", "Admin"]}
							/>
						}
					/>

					<Route
						path={RoutesObject.oficina.list2}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								component={AssistanceList}
								userRoles={userRoles}
								requiredRoles={["Técnico Oficina", "Admin"]}
							/>
						}
					/>

					<Route
						path={`${RoutesObject.oficina.details}/:assistanceId`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								component={AssistanceDetails}
								userRoles={userRoles}
								requiredRoles={["Técnico Oficina", "Admin"]}
							/>
						}
					/>

					{/* Rotas Vista de Backoffice */}
					<Route
						path={RoutesObject.backoffice.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								component={Backoffice}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
							/>
						}
					/>

					<Route
						path={RoutesObject.backoffice.create}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								component={CriarAssistencia}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
							/>
						}
					/>

					<Route
						path={`${RoutesObject.backoffice.create}/:equipmentErpId`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								component={AssistanceCreate}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
							/>
						}
					/>

					<Route
						path={`${RoutesObject.backoffice.details}/:id`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								component={AssistanceEdit}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
							/>
						}
					/>

					{/* Rotas para o agendamento */}

					<Route
						path={RoutesObject.scheduler.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								component={SchedulerIndex}
							/>
						}
					/>

					<Route
						path={`${RoutesObject.scheduler.details}/:assistanceId`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								component={SchedulerIndex}

							/>
						}
					/>

					<Route
						path={RoutesObject.countries.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
								component={CountryIndex}
							/>
						}
					/>

					<Route
						path={RoutesObject.countries.create}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
								component={CountryCreate}
							/>
						}
					/>

					<Route
						path={`${RoutesObject.countries.details}/:id`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
								component={CountryEdit}
							/>
						}
					/>



					{/* Rotas Propostas ao Cliente */}
					<Route
						path={RoutesObject.clientQuotations.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Admin"]}
								component={ClientQuotationIndex}
							/>
						}
					/>
					<Route
						path={RoutesObject.clientQuotations.create}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Técnico Oficina", "Admin"]}
								component={CreateClientQuotation}
							/>
						}
					/>
					<Route
						path={RoutesObject.clientQuotations.details}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Técnico Oficina", "Admin"]}
								component={DetailsClientQuotation}
							/>
						}
					/>


					{/* Rotas Pedidos de Cotacao ao Fornecedor */}
					<Route
						path={RoutesObject.supplierQuotations.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Admin"]}
								component={SupplierQuotationIndex}
							/>
						}
					/>

					<Route
						path={RoutesObject.supplierQuotations.create}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Admin"]}
								component={CreateSupplierQuotation}
							/>
						}
					/>
					<Route
						path={RoutesObject.supplierQuotations.details}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Admin"]}
								component={DetailsSupplierQuotation}
							/>
						}
					/>
					<Route
						path={RoutesObject.reviewClientQuotations.details}
						element={
							<PublicRoute
								component={ReviewClientQuotation}
							/>
						}
					/>
					<Route
						path={RoutesObject.invalidToken.details}
						element={
							<PublicRoute
								component={InvalidToken}
							/>
						}
					/>

					{/* Rotas Planos de Manutenção*/}
					<Route
						path={RoutesObject.maintenancePlans.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Admin"]}
								component={MaintenancePlanIndex}
							/>
						}
					/>

					<Route
						path={`${RoutesObject.maintenancePlans.details}/:id`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Admin"]}
								component={MaintenancePlanEdit}
							/>
						}
					/>

					<Route
						path={RoutesObject.maintenancePlans.create}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Admin"]}
								component={MaintenancePlanCreate}
							/>
						}
					/>

					{/* Rotas KPIs*/}
					<Route
						path={RoutesObject.kpis.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Oficina", "Técnico Escritório", "Admin"]}
								component={KpiIndex}
							/>
						}
					/>
					<Route
						path={RoutesObject.kpis.create}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Oficina", "Técnico Escritório", "Admin"]}
								component={KpiTotalTimeOver7Hours}
							/>
						}
					/>
					<Route
						path={RoutesObject.kpis.details}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Oficina", "Técnico Escritório", "Admin"]}
								component={KpiAssistancesDifferentStartEndDate}
							/>
						}
					/>
					<Route
						path={RoutesObject.kpis.list2}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Oficina", "Técnico Escritório", "Admin"]}
								component={KpiBrandModel}
							/>
						}
					/>
					<Route
						path={RoutesObject.kpis.list3}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Oficina", "Técnico Escritório", "Admin"]}
								component={KpiAssistances}
							/>
						}
					/>
					<Route
						path={RoutesObject.kpis.list4}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Oficina", "Técnico Escritório", "Admin"]}
								component={KpiOpenAssistancesMoreThan10Days}
							/>
						}
					/>
					<Route
						path={RoutesObject.kpis.list5}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Oficina", "Técnico Escritório", "Admin"]}
								component={KpiTechnicianDashboard}
							/>
						}
					/>
					<Route
						path={RoutesObject.kpis.list6}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Oficina", "Técnico Escritório", "Admin"]}
								component={KpiClientDashboard}
							/>
						}
					/>
					<Route
						path={RoutesObject.kpis.list7}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Oficina", "Técnico Escritório", "Admin"]}
								component={KpiClientAssistancesHistoryContainer}
							/>
						}
					/>

					{ /*Rotas Guias de Transporte */}
					<Route
						path={RoutesObject.deliveryNotes.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Admin"]}
								component={DeliveryNoteIndex}
							/>
						}
					/>
					<Route
						path={RoutesObject.deliveryNotesUnsubmitted.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Admin"]}
								component={DeliveryNoteUnsubmittedIndex}
							/>
						}
					/>
					<Route
						path={`${RoutesObject.deliveryNotesUnsubmitted.details}/:id`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Admin"]}
								component={DeliveryNoteEdit}
							/>
						}
					/>

					{/* Rotas Lembretes*/}
					<Route
						path={RoutesObject.reminders.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Admin"]}
								component={ReminderIndex}
							/>
						}
					/>
					<Route
						path={`${RoutesObject.reminders.details}/:id`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Admin"]}
								component={ReminderDetails}
							/>
						}
					/>

					{/* Rotas Subcontratantes*/}
					<Route
						path={RoutesObject.subcontractors.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Admin"]}
								component={SubcontractorIndex}
							/>
						}
					/>

					<Route
						path={`${RoutesObject.subcontractors.details}/:id`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Admin"]}
								component={SubcontractorEdit}
							/>
						}
					/>


					<Route
						path={RoutesObject.subcontractors.create}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								component={SubcontractorCreate}
							/>
						}
					/>

					{/* Rotas Importações*/}
					<Route
						path={RoutesObject.imports.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								component={ImportIndex}
							/>
						}
					/>

					{/* Rotas Estados */}
					<Route
						path={RoutesObject.status.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Admin"]}
								component={StatusIndex}
							/>
						}
					/>
					<Route
						path={RoutesObject.status.create}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Admin"]}
								component={StatusCreate}
							/>
						}
					/>
					<Route
						path={`${RoutesObject.status.details}/:id`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Admin"]}
								component={StatusEdit}
							/>
						}
					/>
					<Route
						path={`${RoutesObject.status.create}/:id`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								component={StatusCreate}
								userRoles={userRoles}
								requiredRoles={technicianHasPermission ? ["Técnico Oficina", "Técnico Escritório", "Admin"] : ["Técnico Escritório", "Admin"]}
							/>
						}
					/>

					{/* Rotas Gestão Fornecedores */}
					<Route
						path={RoutesObject.suppliers.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
								component={SupplierIndex}
							/>
						}
					/>

					<Route
						path={RoutesObject.suppliers.create}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
								component={SupplierCreate}
							/>
						}
					/>

					<Route
						path={`${RoutesObject.suppliers.details}/:id`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
								component={SupplierEdit}
							/>
						}
					/>

					<Route
						path={RoutesObject.checkListModels.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Oficina", "Admin"]}
								component={CheckListModelIndex}
							/>
						}
					/>

					<Route
						path={RoutesObject.checkListModels.create}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Oficina", "Admin"]}
								component={CheckListModelCreate}
							/>
						}
					/>

					<Route
						path={`${RoutesObject.checkListModelTasks.details}/:id`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Oficina", "Admin"]}
								component={CheckListModelTaskDetails}

							/>
						}
					/>

					<Route
						path={`${RoutesObject.checkListModels.details}/:id`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Oficina", "Admin"]}
								component={CheckListModelEdit}

							/>
						}
					/>

					<Route
						path={`${RoutesObject.Holidays.list}`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Admin"]}
								component={HolidayIndex}

							/>

						}
					/>

					<Route
						path={`${RoutesObject.Holidays.create}`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Admin"]}
								component={HolidayCreate}

							/>

						}
					/>

					<Route
						path={`${RoutesObject.Holidays.details}/:id`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Admin"]}
								component={HolidayEdit}

							/>




						}
					/>

					<Route
						path={`${RoutesObject.version.details}`}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Admin"]}
								component={Version}

							/>
						}
					/>

					<Route
						path={RoutesObject.counterTypes.create}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
								component={CounterTypeCreate}
							/>
						}
					/>

					{/* Rotas para Contadores */}
					<Route
						path={RoutesObject.counterTypes.list}
						element={
							<PrivateRoute
								loggedIn={isUserLoggedIn}
								userRoles={userRoles}
								requiredRoles={["Técnico Escritório", "Admin"]}
								component={CounterTypeIndex}
							/>
						}
					/>
				</Routes>
			</BrowserRouter>
		</div>
	);
}

export default App;
